var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarketLoginSelectorSe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6478_15172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-3 0H29V24H-3V0Z",
    fill: "#066AA7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.20001 9.60001H28.8V14.4H-3.20001V9.60001Z",
    fill: "#FECC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.59998 0H10.4V24H5.59998V0Z",
    fill: "#FECC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6478_15172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketLoginSelectorSe);
export default __webpack_public_path__ + "static/media/market_login_selector_se.963a5a683018b09180b9be11f62068e2.svg";
export { ForwardRef as ReactComponent };